import axiosInstance from "../Interceptors/ResponseInterceptor";

export const getSitesWithFilterAndPagination = async (page, pageSize, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await axiosInstance.post(
        `/sites-table?page=${page}&pageSize=${pageSize}`,
        body
      );
      resolve(response.data);
    } catch (error) {
      console.error("Error in createPassword:", error);
      reject(error);
    }
  });
};

export const deleteSiteFromTable = async (siteId) => {
  try {
    const response = await axiosInstance.delete(`/api/delete-site/${siteId}`);
    return response;
  } catch (error) {
    console.error("Error in deleting site:", error);
    throw error;
  }
};
